var map = {
	"./close-btn.webp": 1981,
	"./icon-caution.webp": 1982,
	"./icon-checked.webp": 1983,
	"./icon-contact-us.webp": 1984,
	"./icon-email.webp": 1985,
	"./icon-eye-close.webp": 1986,
	"./icon-eye-open.webp": 1987,
	"./icon-forget-phone.webp": 1988,
	"./icon-google.webp": 1989,
	"./icon-login-email.webp": 1990,
	"./icon-password.webp": 1991,
	"./icon-robot-select.webp": 1992,
	"./icon-robot-unselect.webp": 1993,
	"./icon-telegram.webp": 1994,
	"./icon-user.webp": 1995,
	"./login-bg.webp": 1996,
	"./reglogin-bg-cn.webp": 1997,
	"./reglogin-bg-id.webp": 1998,
	"./reglogin-bg-ms.webp": 1999,
	"./reglogin-bg.webp": 2000,
	"./reglogin-m-bg-cn.webp": 2001,
	"./reglogin-m-bg-id.webp": 2002,
	"./reglogin-m-bg-ms.webp": 2003,
	"./reglogin-m-bg.webp": 2004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;